import PasswordPrompt from 'components/Prompts/PasswordPrompt'
import TableButton from 'components/common/Buttons/TableButton'
import Table from 'components/common/Table'
import useQuery from 'hooks/useQuery'
import React, { useContext, useState } from 'react'
import { ClientDataContext } from 'context/ClientDataContext'
import Calls from './Calls'

const SEARCH_OPTIONS = ['email', 'firstName', 'lastName']
const ORDER_OPTIONS = ['email', 'firstName', 'lastName']

const Accounts = () => {
  const { accounts, fetchAccounts } = useContext(ClientDataContext)

  const [deletePrompt, setDeletePrompt] = useState(null)
  const [selectedAccount, setSelectedAccount] = useState(null)
  const { makeRequest: deleteUser } = useQuery({
    isControlled: true,
    defaultMethod: 'delete',
    toastOptions: {
      showFeedbackMessage: true,
      resultMessageSuccess: 'Usuario borrado',
      resultMessageError: { 401: 'Contraseña incorrecta' },
    },
    reloadTableOnResolve: true,
    disableAutoLogoutOn401: true,
  })
  const aditionalColumns = [
    {
      Header: 'Llamadas',
      Cell: ({
        row: {
          original: {
            id, calls, firstName, lastName,
          },
        },
        cellCustomData,
      }) => {
        return (
          <TableButton
            selected={id === cellCustomData?.id}
            clickHandler={() =>
              setSelectedAccount((ps) =>
                ps?.id === id
                  ? null
                  : {
                    endpoint: calls,
                    title: `${firstName} ${lastName}`,
                    id,
                  })}
          >
            Ver Llamadas
          </TableButton>
        )
      },
    },
    {
      Header: 'Borrar Usuario',
      accessor: ({ id }) => (
        <TableButton
          clickHandler={() => {
            setDeletePrompt({
              title: 'Ingrese su contraseña',
              onOk: async (authPassword) => {
                await deleteUser({
                  endpoint: `/clients/accounts/${id}`,
                  body: { authPassword },
                })
                fetchAccounts()
              },
            })
          }}
        >
          Borrar
        </TableButton>
      ),
    },
  ]
  return (
    <>
      <Table
        title='Mis Cuentas'
        tableData={accounts}
        endpoint='clients/accounts'
        aditionalColumns={aditionalColumns}
        searchOptions={SEARCH_OPTIONS}
        orderOptions={ORDER_OPTIONS}
        cellCustomData={selectedAccount}
        disableAutoScroll
      >
        {selectedAccount && (
          <Calls
            title={`Llamadas de ${selectedAccount.title}`}
            endpoint={selectedAccount.endpoint}
          />
        )}
      </Table>
      {deletePrompt && (
        <PasswordPrompt prompt={deletePrompt} setShowPrompt={setDeletePrompt} />
      )}
    </>
  )
}

export default Accounts
